import { Validators } from '@angular/forms';
import { epRange, epRequiredIf, epValidIf } from './object-rule.validators';

export class RuleNode {
    rule: string; // validation, hide, property, or disable rule - simple or expression with variables.   
    // property rule syntax:  property.label('My Label')  or property.label(FORMULA)
    message?: string; //error message - not used on property rules - simple or with variables
    events?: string; //event extend/override from defaultEvents
    id?: string;
}

export class DesignerRuleNode {
    rule: string;
    message?: string;
    events?: string;
    source?: string;
    core?: boolean; //indicates a rule from a core rule set
    otherSectionRule?: boolean; // indicates rule belongs to other section
}

export class CompiledRuleNode {
    rule: string; //validation, hide, or disable rule - simple or expression with variables.  -- compiled syntax
    message?: string; //error message - simple or with variables  -- compiled syntax
    source?: string; //the source of the rule (copied from the original ObjectRuleSet)
    //sourceRuleNode?: RuleNode;
    events: string;
    dbSectionID?: number; // if set, rules are applied only to the specified section.   Only implemented for visual rules (disable/hide)
    //conditionalRuleFunction?: any; //dynamic function??? -- performance?? put the dynamic function in at compile time
    //conditionalMessageFunction?: any; //dynamic function??? -- performance??  actually put the dynamic function in at compile time
}

export class EvaluatedRuleNode {
    rule: string; //rule -- evaluated(resolved) syntax
    message?: string; //error message -- evaluated(resolved) syntax
    source?: string; //the source of the rule (copied from the original ObjectRuleSet)
    //sourceRuleNode?: RuleNode; // -- add reference to original rule - debug to see source rule and message
}

// pluralize the indexed objects?  fields, validationRules, etc.????????

export class ObjectRuleSet {
    source: string; // NOT IMPLEMENTED: indicates the source of the rule: System.State, System.EditPanel, User.Layout[layoutname], 
    // User.EditPanel[layoutname], User.Book??
    defaultEvents: string;
    objects: {
        [objectNodeType: string]: {
            //objectNodeType: (Contract, CDAA_Vehicle, Location, etc.)
            stateObject: string; // The state object entity that hold this type of data (Contract, Article, Location)
            itemIDField: string; // The ID Field Name (Contract_ID, Article_ID, Loc_ID)
            //XXXitemName: string; // A name for this type of Item (Policy, Vehicle, Location)  -- MOVE TO "RECORD" NODE????
            //XXXitemDesc: string; // A literal or expression with variables to desc the item (ADD EXAMPLE)  -- MOVE TO "RECORD" NODE????
            //XXXitemRules?: RuleNode[]; // list of rules for the record (record level rules, not field level rules)
            fields: {
                [fieldPath: string]: {
                    //fieldPath: path to the field to add rules to (Article.VIN)
                    //name: string; <-- potential future value  *** MAYBE WE NEED FOR RECORD NODE ****
                    desc?: string; //full description for the field - used to identify field in error messages
                    rules?: RuleNode[]; // list of rules for the field
                    //label?: string; // replace label used on field  ** LABELS ARE HANDLED AS RULES NOW **  
                    // Should we use this for the title property on sections?   refactor sections to change title to label?
                };
            };
            variables?: {
                [varName: string]: string;
            };
            //minItems?: number; // NOT IMPLEMENTED
            //maxItems?: number; // NOT IMPLEMENTED
            //defaultItems?: number; // NOT IMPLEMENTED
        };
    };
}

export class CompiledObjectNode {
    stateObject: string;
    itemIDField: string;
    //XXXitemName?: string;
    //XXXitemDesc?: string;
    fields: { [fieldPath: string]: { name?: string; desc: string } };
    parms: { [parmName: string]: { fieldName: string; stateObject: string } };
    disableRules: { [fieldPath: string]: CompiledRuleNode[] };
    hideRules: { [fieldPath: string]: CompiledRuleNode[] };
    validationRules: { [fieldPath: string]: CompiledRuleNode[] };
    propertyRules: { [fieldPath: string]: CompiledRuleNode[] };
}

export class CompiledObjectRules {
    [objectNodeType: string]: {
        stateObject: string;
        itemIDField: string;
        //XXXitemName?: string;
        //XXXitemDesc?: string;
        fields: { [fieldPath: string]: { name?: string; desc: string } }; //DROPPED Label since labels are now handled via rules
        parms: { [parmName: string]: { fieldName: string; stateObject: string } };
        disableRules: { [fieldPath: string]: CompiledRuleNode[] };
        hideRules: { [fieldPath: string]: CompiledRuleNode[] };
        validationRules: { [fieldPath: string]: CompiledRuleNode[] };
        propertyRules: { [fieldPath: string]: CompiledRuleNode[] };
    };
}

export class EvaluatedFieldRuleNode {
    //name?: string; // **** Keep name?
    desc: string;
    validationRules?: EvaluatedRuleNode[];
    disable?: boolean;
    disableMessage?: string;
    hide?: boolean;
    hideMessage?: string;
    label?: string;
    columnSpan?: string;
}

export class EvaluatedObjectRules {
    [fieldPath: string]: EvaluatedFieldRuleNode; //root of fieldPath is formgroup on form (normally matches node in state, 
    // except where multiple state objects are references on one form)
}

export class EvaluatedStateObject {
    stateObject: string;
    objectNode: string;
    itemIDField: string;
    objectID: string;
    fieldRuleResults: { [fieldPath: string]: EvaluatedFieldRuleNode }; //root of field path is node in state
    error?: string; //Critical Error - only reported if problem with the rule defintion for this stateObject
}

//Class used on edit panel to map the form group to the nodeType in the rules engin
export class FormGroupMapping {
    formGroup: string;
    nodeType: any;
}

//Dictionary to look up actual validator functions based on a keyname
export const FormValidatorDictionary = {
    required: Validators.required,
    minLength: Validators.minLength,
    maxLength: Validators.maxLength,
    pattern: Validators.pattern,
    minValue: Validators.min,
    maxValue: Validators.max,
    email: Validators.email, //keep??
    validIf: epValidIf,
    requiredIf: epRequiredIf,
    range: epRange
};
